import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import pageWrapper from '../../containers/AnonPage';
import AuthBox from '../../containers/AuthBox';
import Button from '../../common/Button';
import FormFeedback from '../../common/form/FormFeedback';
import TextInput from '../../common/form/TextInput';
import NewUser, { validationSchema } from '../../../models/NewUser';
import CheckboxInput from '../../common/form/CheckboxInput';
import { doSignup } from '../../../redux/ducks/auth';
import FormResult from '../../../FormResult';

import './SignUp.css';

class SignUpPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      successful: false,
      newUser: null,
    };
  }

  renderSuccessMessage = () => {
    const { newUser } = this.state;

    return (
      <div>
        <h3>You&apos;re signed up, {newUser.first}!</h3>

        <p>Welcome to CollectMe.</p>
        <p>
          We sent an activation link to {newUser.email}. Click that link to activate your account
          and log in.
        </p>
      </div>
    );
  };

  renderSignupForm = () => {
    return (
      <div>
        <h2>Create Account</h2>
        <p className="content">
          Sign up with CollectMe by entering your information below, then click the activation link
          sent to you via email.
        </p>

        <Formik
          initialValues={new NewUser()}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const onSuccess = (r) => {
              setSubmitting(false);
              this.setState({ successful: true, newUser: r });
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            this.props.onSubmit(values, onSuccess, onFailure);
          }}
          validationSchema={validationSchema}
          render={({
            // values,
            // errors,
            // touched,
            status,
            // handleChange,
            // handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <Form>
              <FormFeedback status={status} />

              <div className="columns">
                <div className="column">
                  <Field
                    name="firstName"
                    label="First Name"
                    autoComplete="given-name"
                    component={TextInput}
                  />
                </div>
                <div className="column">
                  <Field
                    name="lastName"
                    label="Last Name"
                    autoComplete="family-name"
                    component={TextInput}
                  />
                </div>
              </div>
              <Field
                name="email"
                label="Email"
                placeholder="you@example.com"
                type="email"
                autoComplete="username"
                component={TextInput}
              />
              <Field
                name="password"
                label="Password"
                placeholder="At least 8 characters"
                type="password"
                autoComplete="new-password"
                component={TextInput}
              />  
              <Field
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                component={TextInput}
              />
              <Field
                name="tosAgreement"
                label="I agree to the Terms of Service and Privacy Policy"
                component={CheckboxInput}
              />

              <Button
                type="submit"
                label="Sign Up"
                color="primary"
                isActive={isSubmitting}
                isDisabled={isSubmitting}
                size="large"
                isFullWidth
                className="signup-button"
                handler={handleSubmit}
              />
            </Form>
          )}
        />
      </div>
    );
  };

  render() {
    const { successful } = this.state;

    return <AuthBox>{successful ? this.renderSuccessMessage() : this.renderSignupForm()}</AuthBox>;
  }
}

SignUpPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (values, onSuccess, onFailure) => {
      dispatch(doSignup(values, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(connect(undefined, mapDispatchToProps)(SignUpPage));



// WEBPACK FOOTER //
// ./src/components/pages/anon/SignUp.jsx